import type { IconData } from '@stacksjs/iconify-core'

export const locationPin: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M42 21c0 12.919-13.35 22.128-17.056 24.436a1.77 1.77 0 0 1-1.888 0C19.351 43.128 6 33.919 6 21c0-9.941 8.059-18 18-18s18 8.059 18 18\"/><path fill=\"#fff\" d=\"M32 21a8 8 0 1 1-16 0a8 8 0 0 1 16 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M42 21c0 12.919-13.35 22.128-17.056 24.436a1.77 1.77 0 0 1-1.888 0C19.351 43.128 6 33.919 6 21c0-9.941 8.059-18 18-18s18 8.059 18 18\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M32 21a8 8 0 1 1-16 0a8 8 0 0 1 16 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPin
